import * as bootstrap from 'bootstrap';
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['emptyModal', 'signModal'];

  connect () {
  }

  openEmptyModal() {
    if (!this.hasEmptyModalTarget) return;

    this.modalInstance = bootstrap.Modal.getOrCreateInstance(this.emptyModalTarget);
    this.modalInstance.show();
  }

  openSignModal() {
    if (!this.hasSignModalTarget) return;

    this.modalInstance = bootstrap.Modal.getOrCreateInstance(this.signModalTarget);
    this.modalInstance.show();
  }
}
